import { Component, ViewChild } from '@angular/core';;
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';
import { Subject } from "rxjs/Subject";
import * as moment from 'moment';
import { fuseAnimations } from '../../../../../../../core/animations';
/**Pipe file */
import { CapitalizePipe } from '../../../../pipesFiles/capitalize.pipe';
// service file
import { EcommerceOrderService } from '../../../order/order.service';
import { EcommerceOrdersService } from '../../orders.service';
import { SolutionFormService } from '../../../solutionForm/solutionForm.service';
import { CommonOrdersService } from '../../commonOrders.service';
import { spekwo, order, orders, spekWalk, displayValues, checkoutFields, spekwoType, requestedWorkPage, toolTip, toastMsg, customerRoles, apiCalls } from '../../../../utils/index';
// Query file
import { CommonQueryService, ReportReviewQueryService, SolutionMasterQueryService } from '../../../../queryFiles/index';
// Local files
import { ToggledListComponent } from '../../../solutionForm/spekwo-type/after-client-accept-list/toggled-list/toggledList.component';
import { SideNavService } from '../../sidenavs/sidenav.service';
//popup component 
import { MatDialog, MatDialogRef } from '@angular/material';
import { FuseConfirmDialogComponent } from '../../../../../../../core/components/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogComponent } from '../../../solutionForm/confirm-dialog/confirm-dialog.component';
import { ToastComponent } from '../../../../common/toast.component';
//Prelist  Pictures 
import { PreListPopUpComponent } from '../pre-list-pop-up/pre-list-pop-up.component'
//Schedule Info Print
import { PrintSchedulingInfoComponent } from '../print-scheduling-info/print-scheduling-info.component';
import { ViewLogsDialogComponent } from '../../../../../../../core/components/view-logs/view-logs.component';

@Component({
    selector: 'request-work-page',
    templateUrl: './request-work-page.component.html',
    styleUrls: ['./request-work-page.component.scss'],
    animations: fuseAnimations,
    providers: [
        CapitalizePipe
    ],
})

export class RequestWorkPageComponent {

    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    emailConfirmRef: MatDialogRef<ConfirmDialogComponent>;

    orderValues = order;
    orders = orders;
    displayValues = displayValues;
    requestedWorkPage = requestedWorkPage;

    apiCalls = apiCalls;
    displayedColumns = ['name', 'solution', 'totalCost'];
    spekwoType = spekwoType;
    spekWalk = spekWalk;
    spekwoValues = spekwo;
    toolTip = toolTip;
    checkoutFields = checkoutFields;
    customerRoles = customerRoles;

    allUserArray = [];
    allRolesArray = [];
    allStatusArray = [];
    allMenuArray = []

    @ViewChild(ToggledListComponent) print: ToggledListComponent;

    dialogRef: any;
    orderType: string;
    public allReviewReports: any[] = [];
    allReviewReports1: any[] = [];
    public acceptedReports: any[] = [];
    isNoData: boolean;
    public acceptedReports1: any[] = [];
    selectedOrder: any = {};
    public unsubscribe = new Subject<void>();
    allSolutionEstimate = [];
    chunkArray = [];
    orderId: number;
    insReportId: string;
    buyerProperty: string;
    requestDate: any;
    scheduleDateByClient: any;
    completedAt: any;
    reinspectionDate: any;

    nodeId: any;
    scheduleByClient: any;
    buyerPropertyAddress: any;

    orderDetails: any = {
        fullName: '',
        email: '',
        mobileNumber: '',
        city: '',
        state: '',
        pincode: '',
        propertyAddress: '',
        metaData: '',
        itemsNumber: '',
    }

    agent: string;
    agentRole: string;
    clientName: string;
    forTotalCost: number = 0; // total cost after saving - admin given
    toggleSolutionTotalCost: number = 0;


    currentpdfUrl: string;
    ishasAttachment: boolean = false;
    isAttachmentLoading: boolean = false;
    isShow: boolean = false;
    isClientAccept: boolean = false;

    totalJobValue: any;
    currentOrderId;

    currentOrderChangedSubscription: Subscription;
    insReportIdChangeSubscription: Subscription;
    orderTypeChangeSubscription: Subscription;
    buyerPropertyChangesSubscription: Subscription;
    clientRoleChangeSubscription: Subscription;
    clientNameSubscription: Subscription;

    onScheduleRequestChangedSubscription: Subscription;


    toastMsg = toastMsg;
    private _subscriptions: Subscription[] = [];
    isEnable: boolean = false;
    isPreList: boolean = true;
    isSpecficItemSpekwo: boolean = false;

    data: any;

    // pdf
    isOrderHasAttachment: boolean = false;
    currentOrderAttachLink: any;
    ocrDocumentUrl: any;

    //New Fields
    clientInfo: any = {
        clientName: '',
        clientEmail: '',
        clientPhone: '',
        clientRole: '',
        agentName: '',
        agentEmail: '',
    };

    transCloseInfo: any = {
        isClose: '',
        whenClose: '',
        beginWork: '',
        closingDate: '',
    };

    closingAttroney: any = {
        name: '',
        phone: '',
    };

    questions: any = {
        whenCompleted: '',
        isPrior: '',
        isocuupied: '',
        workResponsibleRole: '',
        responisblePayment: '',
        progressWorkContact: '',
        paymentContact: '',
        scheduleInfo: '',
        paymentContactEmail: '',
        paymentContactPhone: '',
    };

    dayOfContact: any = {
        name: '',
        phone: '',
        email: '',
    };

    agentNames: any = {
        buyerAgentName: '',
        sellerAgentName: '',
    };
    additional: any = {
        additionalShare: '',
        additionalWork: '',
    };
    occupiedOptions = this.requestedWorkPage.occupiedOptions;
    isPaymentClosed: boolean;
    scheduleData: any;
    scheduleOptions = this.requestedWorkPage.scheduleOptions;

    constructor(
        private router: Router,
        public route: ActivatedRoute,
        public dialog: MatDialog,
        /** Pipe file */
        public capitalizePipe: CapitalizePipe,
        /** Service file */
        private orderService: EcommerceOrderService,
        private solutionFormService: SolutionFormService,
        public ecommerceOrdersService: EcommerceOrdersService,
        public sideNavService: SideNavService,
        public commonOrdersService: CommonOrdersService,
        /** Query file */
        public reportReviewQueryService: ReportReviewQueryService,
        public solutionMasterQueryService: SolutionMasterQueryService,
        /** Local component */
        private toastComponent: ToastComponent,

        public CommonQueryService: CommonQueryService,

    ) { }


    ngOnInit() {
        // get current order from params
        this.route.params.subscribe(params => {
            this.currentOrderId = params.id;
        });

        this.currentOrderChangedSubscription =
            this.solutionFormService.currentOrderChanged.subscribe(res => {

            })

        /**Inspection id  */
        this.insReportIdChangeSubscription =
            this.solutionFormService.insReportIdChange.subscribe(insRes => {
                this.insReportId = insRes && insRes.insReportId;

            })

        /**Buyer property */

        this.buyerPropertyChangesSubscription =
            this.solutionFormService.buyerPropertyChanges.subscribe(propertyRes => {
                this.buyerProperty = propertyRes;

            })

        /**Client  Name -not billing name .Its separate field */
        this.clientNameSubscription =
            this.solutionFormService.clientNameChange.subscribe(data => {

                if (data != undefined) {

                    this.clientName = data && data.name;
                }
            })

        /**Client  role */
        this.clientRoleChangeSubscription =
            this.solutionFormService.clientRoleChange.subscribe(roleRes => {

                this.agent = this.spekwoValues[roleRes];

            })


        //original agent 
        this.getOriginalAgentSubmission();

        //get toggle solution 
        this.getToggleSolution(this.currentOrderId);


        //Pdf final file link.
        this._subscriptions.push(this.ecommerceOrdersService.currentOrderPdfFinalLink.subscribe(res => {

            if (!res.loading) {
                this.isOrderHasAttachment = res.data.isOrderHasAttachment;
                this.currentOrderAttachLink = res.data.currentOrderAttachLink;
            } else {
                this.isOrderHasAttachment = false;
                this.currentOrderAttachLink = '';
            }
        }));

        //pdf
        this._subscriptions.push(
            this.solutionFormService.ocrDocumentChange.subscribe(res => {
                if (!res.loading) {
                    this.ocrDocumentUrl = res.data;
                }
            })
        );

        //order
        this.commonOrdersService.getOrderByOrderId(this.currentOrderId).then((response: any) => {
            let data = response && response.data && response.data.allOrders && response.data.allOrders.nodes.length > 0 && response.data.allOrders.nodes[0] && response.data.allOrders.nodes[0].orderContent ? response.data.allOrders.nodes[0].orderContent : null;
            if (data) {
                let orderContent = JSON.parse(data);
                this.data = orderContent ? orderContent : '';
                var billing = orderContent.billing;
                this.orderDetails.fullName = orderContent && billing && billing.first_name ? billing.first_name + ' ' + billing.last_name : '';
                this.orderDetails.email = orderContent && billing && billing.email ? billing.email : '';
                this.orderDetails.mobileNumber = orderContent && billing && billing.phone ? billing.phone : '';
                this.orderDetails.city = orderContent && billing && billing.city ? billing.city : '';
                this.orderDetails.state = orderContent && billing && billing.state ? billing.state : '';
                this.orderDetails.pincode = orderContent && billing && billing.postcode ? billing.postcode : '';
                if (orderContent && orderContent.meta_data && orderContent.meta_data.length > 0) {
                    let buyerProperty = orderContent.meta_data.filter(data => {
                        return data.key === this.checkoutFields.buyerProperty
                    });
                    let items = orderContent.meta_data.filter(data => {
                        return data.key === this.checkoutFields.itemList
                    });
                    this.orderDetails.propertyAddress = buyerProperty && buyerProperty.length > 0 && buyerProperty[0].value ? buyerProperty[0].value : '';
                    this.orderDetails.metaData = orderContent.meta_data;
                    this.orderDetails.itemsNumber = items && items.length > 0 && items[0].value ? items[0].value : '';
                }
                this.orderType = this.spekwoValues[orderContent.line_items[0].sku];
                if (this.orderType == this.spekwoValues.RJCZPSJ) {
                    this.isPreList = false;
                }
                if (this.orderType == this.spekwoValues.CGPYWCK) {
                    this.isSpecficItemSpekwo = true;
                }
            }
        });

    }

    getOriginalAgentSubmission() {

        this.solutionFormService.checkOrderStatus(this.currentOrderId).then((response: any) => {
            var agentSubmission = response && response.length > 0 && response[0] && response[0].node && response[0].node ? response[0].node : '';
            this.scheduleData = response && response.length > 0 && response[0] && response[0].node && response[0].node ? response[0].node : '';
            let clientRole = this.getvalue(this.customerRoles, agentSubmission.userRole);
            this.clientInfo = {
                clientName: agentSubmission && agentSubmission.contactName ? agentSubmission.contactName : '',
                clientEmail: agentSubmission && agentSubmission.contactEmail ? agentSubmission.contactEmail : '',
                clientPhone: agentSubmission && agentSubmission.contactPhone ? agentSubmission.contactPhone : '',
                clientRole: clientRole ? clientRole : '',
                agentName: agentSubmission && agentSubmission.agentName ? agentSubmission.agentName : '',
                agentEmail: agentSubmission && agentSubmission.agentEmail ? agentSubmission.agentEmail : '',
            };
            this.isPaymentClosed = agentSubmission && agentSubmission.isPaymentClosed ? agentSubmission.isPaymentClosed : false,
                this.transCloseInfo = {
                    isClose: agentSubmission ? (agentSubmission.isPaymentClosed ? 'Yes' : 'No') : '',
                    whenClose: agentSubmission && agentSubmission.scheduleRequestDate ? moment(agentSubmission.scheduleRequestDate).format('MM/DD/YYYY') : '',
                    beginWork: agentSubmission && agentSubmission.workBeginDate ? moment(agentSubmission.workBeginDate).format('MM/DD/YYYY') : '',
                    closingDate: agentSubmission && agentSubmission.closingDate ? moment(agentSubmission.closingDate).format('MM/DD/YYYY') : '',
                };
            this.closingAttroney = {
                name: agentSubmission && agentSubmission.closingName ? agentSubmission.closingName : '',
                phone: agentSubmission && agentSubmission.closingPhone ? agentSubmission.closingPhone : '',
            };
            this.dayOfContact = {
                name: agentSubmission && agentSubmission.workContactName ? agentSubmission.workContactName : '',
                phone: agentSubmission && agentSubmission.workContactPhone ? agentSubmission.workContactPhone : '',
                email: agentSubmission && agentSubmission.workContactEmail ? agentSubmission.workContactEmail : '',
            };
            this.agentNames = {
                buyerAgentName: agentSubmission && agentSubmission.buyerAgentName ? agentSubmission.buyerAgentName : '',
                sellerAgentName: agentSubmission && agentSubmission.sellerAgentName ? agentSubmission.sellerAgentName : '',
            };
            let isOccupied = this.getvalue(this.occupiedOptions, agentSubmission.isOccupied);
            let workResponsibleRole = this.getvalue(this.customerRoles, agentSubmission.wcRole), responisblePayment = this.getvalue(this.customerRoles, agentSubmission.responsibleRole);
            let scheduleInfo = this.getvalue(this.scheduleOptions, agentSubmission.scheduleInfo);
            this.questions = {
                whenCompleted: agentSubmission && agentSubmission.scheduleRequestDate ? moment(new Date(agentSubmission.scheduleRequestDate)).format('MM/DD/YYYY',) : '',
                isPrior: agentSubmission ? (agentSubmission.isPrior ? 'Yes' : 'No') : '',
                isocuupied: isOccupied ? isOccupied : '',
                workResponsibleRole: workResponsibleRole ? workResponsibleRole : '',
                responisblePayment: responisblePayment ? responisblePayment : '',
                progressWorkContact: agentSubmission && agentSubmission.progressContact ? agentSubmission.progressContact : '',
                paymentContact: agentSubmission && agentSubmission.paymentContact ? agentSubmission.paymentContact : '',
                scheduleInfo: scheduleInfo ? scheduleInfo : '',
                paymentContactEmail: agentSubmission && agentSubmission.paymentEmail ? agentSubmission.paymentEmail : '',
                paymentContactPhone: agentSubmission && agentSubmission.paymentPhone ? agentSubmission.paymentPhone : '',
            };
            this.additional = {
                additionalShare: agentSubmission && agentSubmission.additionalShare ? agentSubmission.additionalShare : '',
                additionalWork: agentSubmission && agentSubmission.additionalWork ? agentSubmission.additionalWork : '',
            };
            this.nodeId = agentSubmission.scheduleRequestDate ? agentSubmission.nodeId : '';
            this.scheduleByClient = agentSubmission.scheduleRequestDate ? agentSubmission.scheduleRequestDate : '';
            this.buyerPropertyAddress = agentSubmission.scheduleRequestDate ? agentSubmission.buyerProperty : '';
        }).catch((err) => {
            console.log(err);
        });

    }
    getOption(option) {
        return option ? 'Yes' : 'No';
    }
    getToggleSolution(orderId) {
        this.acceptedReports = [];
        this.acceptedReports1 = [];

        this.toggleSolutionTotalCost = 0;
        if (orderId != undefined) {
            this.solutionFormService.getClientAcceptedSolution(orderId).then((response: any) => {

                if (response && response.masterResponse) {
                    response.masterResponse.forEach((res, key) => {
                        let acceptedResponse = res && res.node && res.node.reportReviewDetailByReviewId ? res.node.reportReviewDetailByReviewId : null;
                        this.acceptedReports.push({
                            name: acceptedResponse.subCategoryName ? acceptedResponse.categoryName ? acceptedResponse.categoryName + ':' + acceptedResponse.subCategoryName : acceptedResponse.subCategoryName : acceptedResponse.categoryName,
                            description: acceptedResponse.description,
                            totalCost: acceptedResponse.totalCost,
                            solution: acceptedResponse.solution,
                            id: acceptedResponse.id,
                            costOption: acceptedResponse.costOption,
                            reviewNodeId: acceptedResponse.nodeId,
                            ni: acceptedResponse.ni,
                            cpi: acceptedResponse.cpi,
                            cpf: acceptedResponse.cpf,
                            tf: acceptedResponse.tf,
                            hourRate: acceptedResponse.hourRate,
                            laborHour: acceptedResponse.laborHour,
                            labourCost: acceptedResponse.labourCost,
                            materialCost: acceptedResponse.materialCost,
                            categoryName: acceptedResponse.categoryName,
                        });
                        this.acceptedReports1.push({

                            name: acceptedResponse.subCategoryName ? acceptedResponse.categoryName ? acceptedResponse.categoryName + ':' + acceptedResponse.subCategoryName : acceptedResponse.subCategoryName : acceptedResponse.categoryName,
                            description: acceptedResponse.description,
                            totalCost: acceptedResponse.totalCost,
                            solution: acceptedResponse.solution,
                            id: res.node.id,
                            costOption: acceptedResponse.costOption,
                            reviewNodeId: acceptedResponse.nodeId,
                            ni: acceptedResponse.ni,
                            cpi: acceptedResponse.cpi,
                            cpf: acceptedResponse.cpf,
                            tf: acceptedResponse.tf,
                            categoryName: acceptedResponse.categoryName,

                        });
                        if (this.acceptedReports.length > 0) {
                            this.isEnable = true;
                            this.isNoData = false;
                        }
                        else {
                            this.isNoData = true;
                        }
                        //calculating total cost
                        this.toggleSolutionTotalCost = Number(this.toggleSolutionTotalCost) + Number(res.node.reportReviewDetailByReviewId.totalCost);
                    });
                }
                else {
                    this.isNoData = true;
                }

            }).catch(err => {
                console.log(err);
                this.acceptedReports = [];
                this.acceptedReports1 = [];
                this.isNoData = true;
            });
        }
    }
    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
        this.currentOrderChangedSubscription.unsubscribe();
        this.insReportIdChangeSubscription.unsubscribe();
        this.buyerPropertyChangesSubscription.unsubscribe();
        this.clientRoleChangeSubscription.unsubscribe();
        this.clientNameSubscription.unsubscribe();
    }




    preListPictures() {
        this.dialog.open(PreListPopUpComponent,
            {
                data: {
                    orderId: this.currentOrderId,
                },
                width: '100%',
                height: '85%',
            });
    }
    printSchedulingInfo() {
        this.dialog.open(PrintSchedulingInfoComponent, { data: this.scheduleData });
    }
    homeInspection() {

        if (this.isOrderHasAttachment) {
            window.open(this.currentOrderAttachLink, '_blank');
        }
        else if (this.ocrDocumentUrl && this.ocrDocumentUrl.message.length > 0) {
            var url = this.apiCalls.ocrDocumentUrl + '/' + this.currentOrderId + '/' + this.ocrDocumentUrl.message[0];
            window.open(url, '_blank');
        }
        else if (!this.isOrderHasAttachment && !(this.ocrDocumentUrl && this.ocrDocumentUrl.message.length > 0)) {
            if (this.orderDetails.metaData.length > 0 && this.orderDetails.metaData) {
                let checkHomeInspection = this.orderDetails.metaData.filter(data => {
                    return data.key === this.checkoutFields.homeInspectionReport
                });
                let url = checkHomeInspection && checkHomeInspection.length > 0 && checkHomeInspection[0].value ? checkHomeInspection[0].value : null;
                if (url) {
                    window.open(url, '_blank');
                }
                else {
                    this.toastComponent.showToast(this.toastMsg.noDocumentUploaded);
                }
            }
            else {
                this.toastComponent.showToast(this.toastMsg.noDocumentUploaded);
            }
        }
        else {
            this.toastComponent.showToast(this.toastMsg.noDocumentUploaded);
        }

    }

    approveSolutionEstimate() {
        if (this.insReportId) {
            this.router.navigate(['/apps/e-commerce/approve-solution-estimate', this.currentOrderId, this.insReportId, "requestWorkPageApprove"]);
        } else {
            this.toastComponent.showToast(this.toastMsg.estimateNotPrepared);
        }

    }
    proSolutionEstimate() {
        if (this.insReportId) {
            this.router.navigate(['/apps/e-commerce/pro-solution-estimate', this.currentOrderId, this.insReportId, "requestWorkPage"]);
        } else {
            this.toastComponent.showToast(this.toastMsg.estimateNotPrepared);
        }

    }
    tableRefresh(event) {
        if (event.flag) {
            this.getToggleSolution(this.currentOrderId);
        }
    }
    getvalue(options, data) {
        let value;
        options.forEach(option => {
            if (option.value == data) {
                value = option.viewValue;
            }
        });
        return value;
    }


    viewLog() {
        this.dialogRef = this.dialog.open(ViewLogsDialogComponent, {
            width: '100%',
            panelClass: 'log-info-dialog',
            data: {
                orderId: parseInt(this.currentOrderId),
            }
        });
        this.dialogRef.afterClosed()
            .subscribe(response => {
                console.log("response", response)
            })
    }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/request-work-page/request-work-page.component.ts